<template>
  <main class="news-cover" :style="headerCompensation">
    <h1>News & Insights</h1>
    <FilterCore v-if="!getIsMobile" :lists="[categories]" />
    <div ref="loader" class="news-cover__entries">
      <CardNews
        class="item"
        v-for="entry in filteredList"
        :key="`news-entry-${entry.id}`"
        :entry="entry"
      />
    </div>
  </main>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { loader, headerCompensation } from '@/mixins';
import CardNews from '@/components/Card/CardNews';
import FilterCore from '@/components/Filter/FilterCore';

export default {
  name: 'NewsCover',
  components: {
    CardNews,
    FilterCore
  },
  // used with Title Mixin
  title: 'News',
  data: () => {
    return {
      content: null,
      isLoading: true,
      categories: {
        label: 'News Types',
        items: null
      }
    };
  },
  mixins: [loader, headerCompensation],
  computed: {
    ...mapGetters(['getIsMobile', 'getFilterNews', 'getIsFilterListLoaded']),
    ...mapState({
      filterNews: state => state.filterNews
    }),
    loadingText() {
      return this.isLoading
        ? 'Loading results...'
        : 'Sorry there are no results';
    },
    filteredList() {
      if (!this.content) return [];

      return this.content;
    }
  },
  watch: {
    filterNews() {
      this.getContent();
    }
  },
  mounted() {
    this.getCategories();
  },
  methods: {
    getContent() {
      this.isLoading = true;
      const queryParams =
        this.getFilterNews !== undefined
          ? `?category=${this.getFilterNews}`
          : '';
      this.$http
        .get(`/api/v1/news.json${queryParams}`)
        .then(response => {
          this.content = response.data.data;
          this.isLoading = false;
          this.$store.commit('setIsFilterListLoaded', true);
        })
        .catch(error => console.error(error));
    },
    getCategories() {
      this.$http
        .get(`/api/v1/categories/news.json`)
        .then(response => {
          this.categories.items = response.data.data;
        })
        .catch(error => console.error(error));
    }
  }
};
</script>

<style lang="postcss">
.news-cover {
  @apply bg-brand-cream;
  h1 {
    @apply font-ginto-black text-center;
    @apply py-16;
    font-size: calc(38px + (80 - 38) * (100vw - 640px) / (1920 - 640));
  }
  &__categories {
    @apply flex flex-col;
    @apply py-16;
    @apply text-center;
    @screen sm {
      @apply text-left;
      @apply flex-row justify-center;
      @apply py-32;
    }
    span {
      @apply mb-8;
      font-size: calc(16px + (26 - 16) * (100vw - 640px) / (1920 - 640));
      @screen sm {
        @apply mb-0;
        @apply mr-8;
      }
    }
    ul {
      @apply list-none;
      li {
        @apply inline-block;
        @apply mr-12;
        @apply border-b border-brand-super-light-blue;
        @apply pb-2;
        @apply cursor-pointer;
        font-size: calc(16px + (26 - 16) * (100vw - 640px) / (1920 - 640));
        &:last-of-type {
          @apply mr-0;
        }
        &.active {
          @apply border-brand-blue;
        }
      }
    }
  }
  &__entries {
    @apply flex flex-wrap;
    @screen sm {
      @apply pt-32;
      @apply max-w-max mx-auto;
      @apply justify-between;
    }
  }
}
</style>
